import { makeAutoObservable } from "mobx";
import { PersistedFilterKeys, PersistedFilterValue } from "./filters.types";

const INITIAL_VALUE = {
  [PersistedFilterKeys.EXCISE_STAMP_REQUEST_LIST]: null,
  [PersistedFilterKeys.EXCISE_LICENCE_REQUEST_LIST]: null,
  [PersistedFilterKeys.MFIN_EXCISE_LICENCE_REQUEST_LIST]: null,
  [PersistedFilterKeys.MFIN_EXCISE_STAMP_REQUEST_LIST]: null,
  [PersistedFilterKeys.MFIN_EXCISE_WAREHOUSE_LIST]: null,
  [PersistedFilterKeys.PRODUCTION_CODE_REQUEST_LIST]: null,
  [PersistedFilterKeys.PU_OBRASCI_LIST]: null,
};

/**
 * Class that handles persisting of filters state
 */
class FiltersStore {
  persistedFilters: { [persistKey: string]: PersistedFilterValue } =
    INITIAL_VALUE;

  constructor() {
    makeAutoObservable(this);
  }

  clearAll() {
    this.persistedFilters = INITIAL_VALUE;
  }

  clearPersistedFilters({
    persistedFilterKey,
  }: {
    persistedFilterKey: PersistedFilterKeys;
  }) {
    this.persistedFilters[persistedFilterKey] = null;
  }

  setPersistedFilters({
    filters,
    persistedFilterKey,
  }: {
    persistedFilterKey: string;
    filters: PersistedFilterValue;
  }) {
    this.persistedFilters[persistedFilterKey] = {
      ...this.persistedFilters[persistedFilterKey],
      ...filters,
    };
  }
}

export const filtersStore = new FiltersStore();
